export enum ContextualSpeedingTab {
    ByVehicle = "byVehicle",
    ByRoad = "byRoad"
}
